<div mat-dialog-title class="dialog-header dialog-info">
  <label class="dialog-title">{{ 'DISPLAY_LANGUAGE_SETTING' | translate }}</label>
  <button type="button" class="btn-close btn-close-white shadow-none dialogClose"
        [mat-dialog-close]></button>
</div>

<div mat-dialog-content class="dialog-body">
  <label>{{ 'DISPLAY_LANGUAGE_SETTINGS_RESTART_MESSAGE' | translate }}</label>
</div>

<div mat-dialog-actions class="dialog-footer" align="end">
  <button mat-raised-button color="primary" (click)="closeDialog()">{{ 'COMMON_DIALOGS_BTN_LABELS_OK' | translate }}</button>
</div>
